import Account from './account/Index'
import Market from './market/Index'
import mbStore from './store'
import mbRouter from './router'
import MailchimpSubscribe from './mailchimp/Subscribe'
import Snackbar from './shared/Snackbar'
import Content from './content/Index'
import Playlist from './youtube/Playlist'
import Channel from './youtube/Channel'
import VueYoutube from 'vue-youtube'
import nest from './nest_api.js'
import AreYouSure from './shared/AreYouSure'
import {statesList} from './helper'

const PROTOCOL = (process.env.VUE_APP_SSL || 'true') =='true' ? 'https' : 'http'
const HOST = {
  nest: process.env.VUE_APP_NEST || 'nest.merchbase.io',
}

const merchbase = {
  install: (Vue, options) => {
    let { store, shopID, shopURI } = options
    let backendSettings = {
      nest: `${PROTOCOL}://${HOST.nest}`,
    }
    Vue.prototype.nestURL = backendSettings.nest

    console.log(`it is a pleasure to serve you from:`, backendSettings)
    window.mbStore = store;

    const nestAPI = new nest(Vue.prototype.nestURL, shopID || process.env.VUE_APP_CONTEXT)

    Vue.component('MbAccountMenu', Account);
    Vue.component('MbMarket', Market);
    Vue.component('MbMailchimpSubscribe', MailchimpSubscribe);
    Vue.component('MbSnackbar', Snackbar)
    Vue.component('MbContent', Content)
    Vue.component('MbYoutubeChannel', Channel)
    Vue.component('MbYoutubePlaylist', Playlist)
    Vue.component('AreYouSure', AreYouSure)
    Vue.use(VueYoutube)
    
    Vue.prototype.merchbase = merchbase;
    Vue.prototype.api = nestAPI;
    Vue.prototype.mbStates = statesList;

    Vue.mixin({
      computed:{
        auth(){return this.$store.getters['account/auth']},
        context(){return shopID || process.env.VUE_APP_CONTEXT || this.api.status().context},
        shopURI(){return shopURI || this.api.status().shopURI},
      },
    });
  
  }
};

export { merchbase, mbStore, mbRouter }; 
